export default "__VITE_ASSET__6kssa3xCT2YlMpIbbRNP$Q__ 220w, __VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 440w, __VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 600w";